import {DocumentMetadata} from '../../entity/model/document-metadata';
import {RequestBody} from '../../entity/core/request-body';
import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {DocumentMetadataUpdateResponse} from '../../entity/dto/marketplace-excel-metadata-update-dto';

export class MetadataAgent {
  getPendingMetadataList = async (requestBody: RequestBody): Promise<DocumentMetadata[]> => {
    return await API.get(awsApiName, '/marketplace-document-metadata', requestBody);
  }

  updateDocumentMetadata = async (requestBody: RequestBody): Promise<DocumentMetadataUpdateResponse> => {
    return await API.put(awsApiName, '/marketplace-document-metadata', requestBody);
  }
}
